import { FEDOPS_APP_NAME } from '../constants/fedops';
import fedopsLoggerFactory from './create-fedops-logger-factory';

export default fedopsLoggerFactory(FEDOPS_APP_NAME).getLogger();



// WEBPACK FOOTER //
// ./app/services/fedops-logger.js